import video from "./images/video/video.mp4";

const Video = {
  video,
};

export default Video;
